import {
  AppstoreOutlined,
  DiffOutlined,
  FileSearchOutlined,
  FullscreenOutlined,
  IdcardOutlined,
  MenuFoldOutlined,
  NotificationOutlined,
  OrderedListOutlined,
  SolutionOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { constantsDictionary } from './dictionary'
import { ROUTES } from './routes'
import { IMenuItems } from './types'

export const mainMenuList: IMenuItems[] = [
  {
    label: constantsDictionary.content,
    key: ROUTES.home,
    icon: <MenuFoldOutlined />,
  },
  {
    label: constantsDictionary.blogs,
    icon: <FullscreenOutlined />,
    key: ROUTES.blogsPosts,
    children: [
      {
        label: constantsDictionary.blog,
        key: ROUTES.blogsPosts,
        icon: <DiffOutlined />,
      },
      {
        label: constantsDictionary.categories,
        key: ROUTES.blogsCategories,
        icon: <OrderedListOutlined />,
      },
    ],
  },
  {
    label: constantsDictionary.seo,
    key: ROUTES.seo,
    icon: <FileSearchOutlined />,
  },
  {
    label: constantsDictionary.hrSection,
    icon: <IdcardOutlined />,
    key: ROUTES.hrSection,
    children: [
      {
        label: constantsDictionary.vacancies,
        key: ROUTES.hrSectionVacancies,
        icon: <SolutionOutlined />,
      },
      {
        label: constantsDictionary.ourTeam,
        key: ROUTES.hrSectionOurTeam,
        icon: <TeamOutlined />,
      },
      {
        label: constantsDictionary.news,
        key: ROUTES.hrSectionNews,
        icon: <NotificationOutlined />,
      },
    ],
  },
]
